import { Formatters } from '@axo/shared/util/string';

const formatSpacedNumber = (value: string) =>
  Formatters.getNumberFormatter(value, ' ');

const formatNumber = (value: string) =>
  Formatters.getNumberFormatter(value, '');

export { formatNumber, formatSpacedNumber };
